var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01248 0.5C4.91386 0.5 4.01498 1.45625 4.01498 2.625V4.75H0.19975C0.0799001 4.75 0.019975 4.835 0.019975 4.94125V10.0625C0.019975 10.6575 0.459426 11.125 1.01873 11.125H15.0012C15.5605 11.125 16 10.6575 16 10.0625V4.94125C16 4.81375 15.9201 4.75 15.8202 4.75H12.005V2.625C12.005 1.45625 11.1061 0.5 10.0075 0.5L6.01248 0.5ZM6.01248 2.625H10.0075V4.75H6.01248V2.625ZM0.019975 13.0588V17.3088C0.019975 17.415 0.0998752 17.5 0.19975 17.5H15.8003C15.9001 17.5 15.98 17.415 15.98 17.3088V13.0588C15.6604 13.1862 15.3408 13.25 14.9813 13.25H0.998752C0.639201 13.25 0.3196 13.165 0 13.0588H0.019975Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkPosition);
export default __webpack_public_path__ + "static/media/icon-work-position.69407404d46c21ae20d64c7a703a93b4.svg";
export { ForwardRef as ReactComponent };